// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/vfr-minima.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/vfr-minima/special-vfr-minima.js';
import g1 from '../lessons/air-law/vfr-minima/vfr-minima.js';

mount([g0, g1]);
